import React from "react";
import homeStyles from "./publicHomePage.module.css";
import { MdLabelImportantOutline } from "react-icons/md";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import publicHome from "../../../images/publicHome.png";
import learnTogether from "../../../images/learnTogether.png";
import learningZone from "../../../images/learningzone .webp";
import cultures from "../../../images/cultures.webp";
import AngelaWilliams from "../../../images/AngelaWilliams.png";
import JamesThomas from "../../../images/JamesThomas.png";
import SandraJohnson from "../../../images/SandraJohnson.png";
import search from "../../../images/search.png";
import registerFree from "../../../images/registerFree.png";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
    slidesToSlide: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    slidesToSlide: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

const publicHomePage = () => {
  /* The Public Home Page is the home page of the website shown by guests (users who are not logged in). The page contains information about the website and its features, and it has a link to the login page. */

  return (
    <div className={homeStyles.mainHomeStyles}>
      <div className={homeStyles.topDiv}>
        <h2>Start Learning a New Language, as Part of Our Awesome Community</h2>
        <figure className={homeStyles.figure}>
          <img src={publicHome} alt="World wide language learning" />
        </figure>
      </div>

      <div className={homeStyles.middleDiv}>
        <figure className={homeStyles.figure2}>
          <img src={learnTogether} alt="Learn together" />
        </figure>
        <div className={homeStyles.textArea}>
          <p>
            <MdLabelImportantOutline /> Use our Language Exchange services to
            find people who can help you learn your desired language, in
            exchange for helping them learn your native language.
          </p>
          <p>
            <MdLabelImportantOutline /> Find same-language learners, who want to
            learn the same language you want to, and learn together online.
          </p>
        </div>
      </div>
      <h3 className={homeStyles.whatWeOffer}>What we offer</h3>
      <div className={homeStyles.carouselAbout}>
        <Carousel
          showDots={false}
          responsive={responsive}
          infinite={true}
          autoPlay={true}
          autoPlaySpeed={3000}
          keyBoardControl={true}
          customTransition="all .5"
          transitionDuration={500}
          removeArrowOnDeviceType={["tablet", "mobile"]}
          className={homeStyles.carousel1}
        >
          <figure>
            <img src={learningZone} alt="learningZone" />
            <figcaption>
              Online Learning Zones with dedicated tools for learning a new
              language.
            </figcaption>
          </figure>
          <figure>
            <img src={cultures} alt={"Cultures"} />
            <figcaption>
              Get to know people from all over the world and familiarize
              yourself with foreign cultures
            </figcaption>
          </figure>
          <figure>
            <img src={search} alt={"Search"} />
            <figcaption>
              A powerful search engine, for finding Language Exchange partners
              and same - language learners.
            </figcaption>
          </figure>
          <figure>
            <img src={registerFree} alt={"Register Free"} />
            <figcaption>
              Registering and using most of our basic tools are free!
            </figcaption>
          </figure>
        </Carousel>
      </div>

      <h3 className={homeStyles.whatWeOffer}>Our users' Experiences</h3>
      <div className={homeStyles.carouselExperience}>
        <div>
          <p>
            "I've been using Speaker for a while, and had a lot of fun. It is
            very beneficial for learning a new language."
          </p>
          <figure>
            <img src={AngelaWilliams} alt="Angela Williams" />
            <figcaption>Angela Williams</figcaption>
          </figure>
        </div>
        <div>
          <p>"Awesome platform!!"</p>
          <figure>
            <img src={JamesThomas} alt="James Thomas" />
            <figcaption>James Thomas</figcaption>
          </figure>
        </div>
        <div>
          <p>"The website has a great user experience!"</p>
          <figure>
            <img src={SandraJohnson} alt="Sandra Johnson" />
            <figcaption>Sandra Johnson</figcaption>
          </figure>
        </div>
      </div>
    </div>
  );
};

export default publicHomePage;
